export default __webpack_public_path__ + "static/media/micbutton.305a92db.png";